import * as React from 'react';
import {RiveState, useRive} from '@rive-app/react-canvas';
import {Button} from 'onboarding-components';
import produce from 'immer';

import {openDemoProjectSelectorModal} from 'common/widgets/demo-selector-modal';
import {SetupGuideContext, Step, SubStep} from 'common/onboarding/immersive-onboarding/types';
import {scrollToStep} from 'common/onboarding/immersive-onboarding/components/scroll-manager';
import {track, TrackingEvent, TrackingProperty} from 'common/onboarding/immersive-onboarding/tracking';
import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {EventSubStepContext} from 'common/onboarding/immersive-onboarding/steps/events/common';
import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets';
import {ApiClient} from 'common/onboarding/immersive-onboarding/api-client';

import styles from './ready-to-connect.module.styl';

// TODO: Remove this after V1.1/2 is GA
export const ReadyToConnect = () => {
  const {setSetupGuideInfo, setupGuideInfo} = React.useContext(SetupGuideContext);
  const {rive, RiveComponent}: RiveState = useRive({
    src: IMMERSIVE_ASSETS.readyToConnect,
    stateMachines: [`State Machine 1`],
  });

  const {eventSubStep} = React.useContext(EventSubStepContext);

  // TODO: probably should use IntersectionObserver for this
  React.useEffect(() => {
    let timer;
    if (eventSubStep === SubStep.ReadyToConnect) {
      timer = setTimeout(() => {
        rive.play();
      }, 700);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [eventSubStep]);

  return (
    <div className={styles.readyToConnect}>
      <div className={styles.content}>
        <div className={styles.footer}>
          <Button
            onClick={() => {
              track(TrackingEvent.SubStepCompleted, {[TrackingProperty.SubStepName]: SubStep.ReadyToConnect});
              scrollToStep(Step.Implement);

              const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, (draft) => {
                draft.add(Step.Events);
              });
              ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
              setSetupGuideInfo({...setupGuideInfo, stepsCompleted: updatedStepsCompleted});
            }}
          >
            Connect your data
          </Button>
          <Button
            variant='inline'
            includeArrow={false}
            onClick={() => {
              track(TrackingEvent.ViewDemoClick, {[TrackingProperty.SubStepName]: SubStep.ReadyToConnect});
              openDemoProjectSelectorModal(
                (ev) => {
                  addToast({message: ev.detail.message, type: ToastType.ERROR});
                },
                {'is-new-tab': true},
              );
            }}
          >
            View a demo project
          </Button>
        </div>
      </div>
      <RiveComponent style={{height: `255px`, width: `400px`}} />
    </div>
  );
};
